// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__73b7db67","labelGroup":"labelGroup__73b7db67","label":"label__73b7db67","age":"age__73b7db67","datePicker":"datePicker__73b7db67"};